import React, { useEffect, useState } from "react";
import api from "../../api/api";
import Sidebar from "../../components/Sidebar"; // existing sidebar
import "../../css/leads/leadadmintable.css";

export default function LeadsAdminTable() {
  const [leads, setLeads] = useState([]);
  const [search, setSearch] = useState("");

  useEffect(() => {
    fetchLeads();
  }, []);

  const fetchLeads = async () => {
    try {
      const res = await api.get("/leads/all");
      setLeads(res.data);
    } catch (err) {
      console.error("Failed to fetch leads:", err);
    }
  };

  const filteredLeads = leads.filter(
    (lead) =>
      lead.full_name?.toLowerCase().includes(search.toLowerCase()) ||
      lead.email?.toLowerCase().includes(search.toLowerCase()) ||
      lead.createdByEmail?.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className="admin-page">
      {/* Sidebar */}
      <Sidebar />

      {/* Main Content */}
      <div className="admin-content">
         <div className="admin-table-container">
        <h2 className="page-title">All Leads</h2>

        {/* <div className="admin-table-container"> */}
          <div className="table-actions">
            <input
              type="text"
              placeholder="Search by name, email or created by"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              className="search-input"
            />
          </div>

          <div className="table-scroll">
            <table className="admin-table">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Full Name</th>
                  <th>Email</th>
                  <th>Phone</th>
                  <th>Lead Type</th>
                  <th>Source</th>
                  <th>Status</th>
                  <th>Budget Min</th>
                  <th>Budget Max</th>
                  <th>Preferred Locations</th>
                  <th>Property Type</th>
                  <th>Interest Level</th>
                  <th>Notes</th>
                  <th>Created By</th>
                  <th>Created At</th>
                </tr>
              </thead>

              <tbody>
                {filteredLeads.length > 0 ? (
                  filteredLeads.map((lead, index) => (
                    <tr key={lead._id}>
                      <td>{index + 1}</td>
                      <td>{lead.full_name || "-"}</td>
                      <td>{lead.email || "-"}</td>
                      <td>{lead.phone || "-"}</td>
                      <td>{lead.lead_type || "buyer"}</td>
                      <td>{lead.source || "website"}</td>
                      <td className={`status ${lead.status || "new"}`}>
                        {lead.status || "new"}
                      </td>
                      <td>{lead.budget_min || "-"}</td>
                      <td>{lead.budget_max || "-"}</td>
                      <td>
                        {Array.isArray(lead.preferred_locations)
                          ? lead.preferred_locations.join(", ")
                          : "-"}
                      </td>
                      <td>{lead.property_type || "apartment"}</td>
                      <td>{lead.interest_level || "warm"}</td>
                      <td>{lead.notes || "-"}</td>
                      <td>{lead.createdByEmail || "-"}</td>
                      <td>
                        {lead.createdDate
                          ? new Date(lead.createdDate).toLocaleString("en-IN", {
                              dateStyle: "medium",
                              timeStyle: "short",
                            })
                          : "-"}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={15} className="empty-state">
                      No leads found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}
